import isDate from '../type-check/is-date.js';
import isISODate from '../type-check/is-iso-date.js';
import isMDY from '../type-check/is-mdy.js';
import isYM from '../type-check/is-ym.js';
import isYMD from '../type-check/is-ymd.js';

/**
 * @func parseDate
 * @param {date} date - Date to be parsed (accepts date object, ISO strings, YM, YMD, and MDY date strings)
 * @return {date}
 * @desc Parses dates. Converts ISO strings and date strings to date objects.
 * YMD and MDY date objects are set to midnight in machine's local time.
 * YM is set to the first day of the month at midnight in machine's local time.
 * ```js
 * parseDate('5/3/2020');
 * // returns a date object with this date
 * ```
 * @memberof module:Date
 * @instance
 */
// Converts YM and YMD to MDY because JavaScript sets YM and YMD time to midnight UTC instead of local.
const toMDY = (date) => {
    const dateArray = date.split('-');
    if (dateArray.length === 2)
        dateArray.push('01');
    const monthDayYear = [dateArray[1], dateArray[2], dateArray[0]].join('/');
    return new Date(monthDayYear);
};
function parseDate(date) {
    if (isDate(date))
        return date;
    if (isYMD(date) || isYM(date))
        return toMDY(date);
    if (isISODate(date) || isMDY(date))
        return new Date(date);
    return null;
}

export { parseDate as default };
